__turbopack_context__.v({
  "badge": "ContentItem-module-scss-module__QD9vgq__badge",
  "catContainer": "ContentItem-module-scss-module__QD9vgq__catContainer",
  "content": "ContentItem-module-scss-module__QD9vgq__content",
  "contentContainer": "ContentItem-module-scss-module__QD9vgq__contentContainer",
  "contentItemContainer": "ContentItem-module-scss-module__QD9vgq__contentItemContainer",
  "ctmLink": "ContentItem-module-scss-module__QD9vgq__ctmLink",
  "dateTime": "ContentItem-module-scss-module__QD9vgq__dateTime",
  "datum": "ContentItem-module-scss-module__QD9vgq__datum",
  "icon": "ContentItem-module-scss-module__QD9vgq__icon",
  "intro": "ContentItem-module-scss-module__QD9vgq__intro",
  "mdKey": "ContentItem-module-scss-module__QD9vgq__mdKey",
  "mdRow": "ContentItem-module-scss-module__QD9vgq__mdRow",
  "mdValue": "ContentItem-module-scss-module__QD9vgq__mdValue",
  "mdValueKenmerk": "ContentItem-module-scss-module__QD9vgq__mdValueKenmerk",
  "mdValueType": "ContentItem-module-scss-module__QD9vgq__mdValueType",
  "menuContainer": "ContentItem-module-scss-module__QD9vgq__menuContainer",
  "menuOption": "ContentItem-module-scss-module__QD9vgq__menuOption",
  "metaMenuCol": "ContentItem-module-scss-module__QD9vgq__metaMenuCol",
  "productTag": "ContentItem-module-scss-module__QD9vgq__productTag",
  "tag": "ContentItem-module-scss-module__QD9vgq__tag",
  "tagsContainer": "ContentItem-module-scss-module__QD9vgq__tagsContainer",
  "teVergroten": "ContentItem-module-scss-module__QD9vgq__teVergroten",
  "terugButton": "ContentItem-module-scss-module__QD9vgq__terugButton",
  "titel": "ContentItem-module-scss-module__QD9vgq__titel",
  "variantContainer": "ContentItem-module-scss-module__QD9vgq__variantContainer",
});
